var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsSquarePlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.5 0A6.5 6.5 0 0 1 20 6.5v7a6.5 6.5 0 0 1-6.5 6.5h-7A6.5 6.5 0 0 1 0 13.5v-7A6.5 6.5 0 0 1 6.5 0zM10 5a.79.79 0 0 0-.79.79v3.42H5.79a.79.79 0 1 0 0 1.58l3.42-.001v3.422a.79.79 0 1 0 1.58 0l-.001-3.422h3.422a.79.79 0 1 0 0-1.578l-3.422-.001V5.79A.79.79 0 0 0 10 5"
})));
export default SvgIconsSquarePlus;